// @ts-nocheck

export const nativeEventTypes = {
  ORIENTATION_CHANGE: 'orientationchange',
};

const nativeEventListeners = {};

export const onNativeEvent = (type, data) => {
  console.debug(`%c bridge | onNativeEvent %O`, 'background: #616161; color: #fff;', { type, data });
  nativeEventListeners[type]?.forEach((handler) => handler(data));
};

export const addNativeEventListener = (type, listener) => {
  if (!nativeEventListeners[type]) {
    nativeEventListeners[type] = [listener];
  } else {
    nativeEventListeners[type].push(listener);
  }
};

export const removeNativeEventListener = (type, listener) => {
  const index = nativeEventListeners[type]?.indexOf(listener) ?? -1;

  if (index !== -1) {
    nativeEventListeners[type].splice(index, 1);
  }
};
